export default "__VITE_ASSET__C3h0UZv4__"